import { select } from '@js/util/select.js'
import $ from 'jquery'

select('.faq-filter [name="category"]', element => {
  $(element).on('change', function () {
    $(this).closest('.faq-filter')[0]?.requestSubmit()
  })
})
